import { Directive, ElementRef, Input, Output, EventEmitter, Renderer2, NgZone } from '@angular/core';
/**
 * @hidden
 */
var EventsOutsideAngularDirective = (function () {
    function EventsOutsideAngularDirective(element, ngZone, renderer) {
        this.element = element;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.eventNames = [];
        this.domEventHandler = new EventEmitter();
    }
    EventsOutsideAngularDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.element || !this.element.nativeElement) {
            return;
        }
        var names = [].concat(this.eventNames);
        this.subscriptions = [];
        this.emitEvent = this.emitEvent.bind(this);
        this.ngZone.runOutsideAngular(function () {
            for (var idx = 0; idx < names.length; idx++) {
                _this.subscriptions.push(_this.renderer.listen(_this.element.nativeElement, names[idx], _this.emitEvent));
            }
        });
    };
    EventsOutsideAngularDirective.prototype.ngOnDestroy = function () {
        if (this.subscriptions) {
            for (var idx = 0; idx < this.subscriptions.length; idx++) {
                this.subscriptions[idx]();
            }
            this.subscriptions = null;
        }
    };
    EventsOutsideAngularDirective.prototype.emitEvent = function (args) {
        this.domEventHandler.emit(args);
    };
    return EventsOutsideAngularDirective;
}());
export { EventsOutsideAngularDirective };
EventsOutsideAngularDirective.decorators = [
    { type: Directive, args: [{
                selector: '[kendoEventsOutsideAngular]'
            },] },
];
/** @nocollapse */
EventsOutsideAngularDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NgZone, },
    { type: Renderer2, },
]; };
EventsOutsideAngularDirective.propDecorators = {
    'eventNames': [{ type: Input },],
    'domEventHandler': [{ type: Output, args: ['kendoEventsOutsideAngular',] },],
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/common/events-outside-angular.directive.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/common/events-outside-angular.directive.js
// module chunks = 3